import { UpgradeReportType } from '@/types/upgradereporttype';
import { UpgradeJobType, UpgradeJob } from '@/types/upgradejob';

export interface UpgradeJobTab {
    id: string,
    label: string,
    jobs: Array<UpgradeJob>
    requiresSelectedCycleBeforeJobHistoryCanLoad: boolean
  }

export const upgradeJobTabs: (UpgradeJobTab) [] = [
  {
    id: 'settings-and-config-upgrade-report',
    label: 'Settings & Config Upgrade Report',
    jobs: [{
      id: UpgradeJobType.SETTINGS,
      reports: [UpgradeReportType.SETTINGS],
    }],
    requiresSelectedCycleBeforeJobHistoryCanLoad: false,
  },
  {
    id: 'akk-mapping',
    label: 'AKK Mapping',
    jobs: [{
      id: UpgradeJobType.AKK,
      reports: [UpgradeReportType.AKK, UpgradeReportType.NOAKK],
    }],
    requiresSelectedCycleBeforeJobHistoryCanLoad: false,
  },
  {
    id: 'ascad-and-tunes-seeding',
    label: 'ASCAD & Tunes Seeding',
    jobs: [
      {
        id: UpgradeJobType.ASCAD,
        reports: [UpgradeReportType.ASCAD],
      },
      {
        id: UpgradeJobType.TUNES,
        reports: [UpgradeReportType.TUNES, UpgradeReportType.TUNES_DEBITS],
      },
    ],
    requiresSelectedCycleBeforeJobHistoryCanLoad: true,
  },
  {
    id: 'qual-rewards-linkedaccounts-comparisons',
    label: 'Qualifications/Rewards & Linked Accounts Comparison',
    jobs: [
      {
        id: UpgradeJobType.QUALIFICATIONS,
        reports: [UpgradeReportType.QUALIFICATIONS],
      },
      {
        id: UpgradeJobType.REWARDS,
        reports: [UpgradeReportType.REWARDS],
      },
      {
        id: UpgradeJobType.LINKED_ACCOUNTS,
        reports: [UpgradeReportType.LINKED_ACCOUNTS],
      },
    ],
    requiresSelectedCycleBeforeJobHistoryCanLoad: false,
  },
];


export default upgradeJobTabs;
